import {
  Download04Icon,
  Image02Icon,
  Link02Icon,
  PlayIcon,
  TextIcon,
  CodeIcon
} from '@hugeicons/react'

import { Badge } from '@/shared/ui/Badge'
import type { DocumentArchiveKind } from '@/types/document'

const KIND_CONFIG: Record<
  string,
  { label: string; icon: typeof Link02Icon }
> = {
  link: { label: 'Link', icon: Link02Icon },
  archive: { label: 'PDF', icon: Download04Icon },
  image: { label: 'Imagem', icon: Image02Icon },
  video_url: { label: 'Vídeo', icon: PlayIcon },
  embedded: { label: 'Embed', icon: CodeIcon },
  text: { label: 'Texto', icon: TextIcon }
}

type ResourceTypeBadgeProps = {
  kind: DocumentArchiveKind | null | undefined
  className?: string
}

export const ResourceTypeBadge = ({ kind, className }: ResourceTypeBadgeProps) => {
  const config = KIND_CONFIG[kind ?? '']
  if (!config) return null

  const Icon = config.icon

  return (
    <Badge
      variant="locked"
      tone="light"
      size="sm"
      showIcon
      icon={<Icon size={10} aria-hidden />}
      className={className}
    >
      {config.label}
    </Badge>
  )
}
